import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPublonsComponent } from './simple-icons-publons.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPublonsComponent ],
    exports:      [ SimpleIconsPublonsComponent ],
    bootstrap:    []
})
export class SimpleIconsPublonsModule {}
